module.exports = __webpack_public_path__ + "img/DE05804.d209f847.png";